import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import type { Props as RootDataTableProps } from '@components/DataTable';
import RootDataTable from '@components/DataTable';
import { RouterLink } from '@redux-first-router-link';

export interface Props extends RootDataTableProps {
  disabled?: boolean;
}

export default styled(RootDataTable)<Props>`
  border-color: transparent;
  a,
  button {
    -webkit-tap-highlight-color: transparent;
  }
  thead tr th {
    background: transparent;
    ${({ theme }) => theme.typography.tinyStrong};
    color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  }
  tr {
    height: auto;
    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }
  th,
  td {
    border-top: none;
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    vertical-align: middle;
    &:last-child {
      text-align: left;
    }
  }
  th {
    padding: ${({ theme }) => `10px ${theme.x1spacePx}px`};
  }
  td {
    ${({ theme }) => theme.typography.xSmall};
    height: ${({ theme }) => theme.x8spacePx}px;
    padding: 0;
    ${({ disabled }) => disabled && `background: none !important;`}
  }
  > tbody > tr {
    > td {
      background: transparent;
      transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);
      > a,
      > span {
        padding: ${({ theme }) => `10px ${theme.x1spacePx}px`};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration: none;
        color: inherit;
        cursor: ${({ disabled }) => (disabled ? `auto` : `pointer`)};
      }
    }
    ${media.lgUp`
      &:hover {
        > td {
          background: ${({ theme }) => theme.color.noir};
        }
      }
      &:active {
        > td {
          transition-duration: 0s;
          background: ${({ theme }) => theme.color.phantom};
        }
      }
    `}
  }
`;

interface CellLinkProps {
  as?: string;
  to?: ReducerAction | string;
}

export const CellLink = styled(RouterLink)<CellLinkProps>`
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  text-decoration: none;
  color: inherit;
`;
